import React, { Component } from 'react'
import {Box, Button, Container, Divider,Menu,Modal ,Grid,Toolbar,FormControl,Link, Typography,Checkbox, IconButton,TextField,MenuItem,Paper, AppBar} from '@mui/material'
import CloseIcon from "@mui/icons-material/Close";
import logo from '../src/img/logo.png'
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
//////////// image details///////////////
import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined';
import {useLocation,useNavigate,useParams} from 'react-router-dom'
     import AccountCircleIcon from '@mui/icons-material/AccountCircle';
      import HowToRegIcon from '@mui/icons-material/HowToReg';
import YouTubeIcon from '@mui/icons-material/YouTube';
import EmailIcon from '@mui/icons-material/Email';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import InputAdornment from '@mui/material/InputAdornment';

import AccountCircle from '@mui/icons-material/AccountCircle';
import PersonIcon from '@mui/icons-material/Person';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import LockIcon from '@mui/icons-material/Lock';
import base from '../src/base.json'
 import MenuIcon from '@mui/icons-material/Menu';





export class Appbars extends Component {

  constructor(props) {
    super(props)
   this.state = {
      anchorEl : null,
      open: false,

      is_login_open : false,

      
       email :"",
       password : "",
     

       showpassword : false,

    }
    this.setAnchorEl = this.setAnchorEl.bind(this)
    this.handleClick = this.handleClick.bind(this)
    this.handleClose = this.handleClose.bind(this)
  };
  

  handleClick(event) {
    this.setAnchorEl(event.currentTarget);
}
  setAnchorEl(value){
        this.setState({
            anchorEl: value,
            open: !this.state.open
        })
    }
handleClose() {
    this.setAnchorEl(null);
}

handleChange=(e)=>{
  this.setState({
    [e.target.name] : e.target.value
  })
}



isObject=(o)=>{
  return o instanceof Object && typeof o.constructor === 'function';
}



renderMenu(){
  return(
    <Box sx={{}}>
  <Menu id="fade-menu" anchorEl={this.state.anchorEl} open={this.state.open}  onClose={this.handleClose}>
       
            <MenuItem  component='a'  sx={{fontSize:12,fontWeight:'bold'}} href='/' onClick={this.handleClose}>Home</MenuItem>
                  <MenuItem  component='a'  sx={{fontSize:12,fontWeight:'bold'}} href='/about' onClick={this.handleClose}>About us</MenuItem>
                        <MenuItem  component='a'  sx={{fontSize:12,fontWeight:'bold'}} href='/contact' onClick={this.handleClose}>Contact us</MenuItem>
                              <MenuItem  component='a'  sx={{fontSize:12,fontWeight:'bold'}} href='/blog' onClick={this.handleClose}>Blogs</MenuItem>
                                    <MenuItem  component='a'  sx={{fontSize:12,fontWeight:'bold'}} href='/faq' onClick={this.handleClose}>Faqs</MenuItem>

    </Menu>
    </Box>
   )
}


login=()=>{


}



  render() {
    return (
      <div>
   
       <AppBar position="fixed"   sx={{display:'flex',backgroundColor:'#fff',width:'100%',borderBottom:1,borderColor:'#e26511',top:0,left:0,right:0}}>
      
     
        <Toolbar variant="dense">
          <Container maxWidth='xl'>
         <Box sx={{width:'100%',display:'flex',flexDirection:'row',justifyContent:'space-between',alignItems:'center'}}>
          
          <Link href='/'>
           <Box sx={{height:50, width:100,display:'flex',justifyContent:'center',alignItems:'center'}}>
           <img src={logo} style={{height:38,width:100}}/>
           </Box>
           </Link>
       
           <Box sx={{display:'flex',flexDirection:'row'}}>
              <Button  component='a' href='/' variant='contained' disableElevation sx={{fontWeight:'bold',height:30,mr:1,borderRadius:4,fontSize:12,backgroundColor:'#f85c19',mt:{xs:1,sm:0},display:{xs:'none',sm:'block'},textTransform:'none'}}>
               Home
             </Button>

               <Button  component='a' href='/about'  variant='outlined' disableElevation sx={{fontWeight:'bold',height:30,mr:1,borderRadius:4,fontSize:12,mt:{xs:1,sm:0},display:{xs:'none',sm:'block'},textTransform:'none'}}>
               About us
             </Button>

               <Button component='a' href='/contact'  variant='outlined' disableElevation sx={{fontWeight:'bold',height:30,mr:1,borderRadius:4,fontSize:12,mt:{xs:1,sm:0},display:{xs:'none',sm:'block'},textTransform:'none'}}>
               Contact
             </Button>

               <Button component='a' href='/faq' variant='outlined' disableElevation sx={{fontWeight:'bold',height:30,mr:1,borderRadius:4,fontSize:12,mt:{xs:1,sm:0},display:{xs:'none',sm:'block'},textTransform:'none'}}>
               Faq
             </Button>
       

            
             <IconButton  aria-owns={this.state.open ? 'fade-menu' : undefined} onClick={this.handleClick} sx={{height:34,fontSize:14,fontWeight:'600',ml:0.5,textTransform:'none',display:{xs:'block',sm:'none'},mt:{xs:0.5,sm:0}}}>
              <MenuIcon/>
             </IconButton> 

       
            

{this.renderMenu()}

       

       
           </Box>
       
         </Box>
       </Container>
       
       </Toolbar>

     
       </AppBar>



      <Box sx={{height:200,width:40,backgroundColor:'', display:'flex',flexDirection:'column',position:'fixed',left:0,top:300}}>
        <Paper  sx={{height:50,width:45,borderBottom:1,borderColor:'#fff',display:'flex',justifyContent:'center',alignItems:'center',borderRadius:0,backgroundColor:'#f42f3a'}}>
          <YouTubeIcon  onClick={()=>window.open(" https://www.youtube.com/channel/UCNrwKrA9-")}   sx={{height:25,width:25,color:'#fff'}}/>
        </Paper>
        <Paper sx={{height:50,width:45,borderBottom:1,borderColor:'#fff',display:'flex',justifyContent:'center',alignItems:'center',borderRadius:0,backgroundColor:'#e04990'}}>
           <InstagramIcon  onClick={()=>window.open("https://www.instagram.com//")}  sx={{height:25,width:25,color:'#fff'}}/>
        </Paper>
        <Paper sx={{height:50,backgroundColor:'#3a54a1',width:45,display:'flex',justifyContent:'center',alignItems:'center',borderRadius:0}}>
          <FacebookIcon  onClick={()=>window.open("https://www.facebook.com/share//")}  sx={{height:25,width:25,color:'#fff'}}/>
        </Paper>
      </Box>






{
  /////// login
}

    <Box>
          <Modal
            open={this.state.is_login_open}
            onClose={this.handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                width: "100%",
              }}
            >
              <Paper
                sx={{
                  width: { xs: "90%", sm: "90%", md: "25%", lg: "25%" },
                  height: "80vh",
                  backgroundColor: "#fff",
                  borderRadius: 2,
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "right",
                  }}
                >
                  <Paper
                    onClick={() =>
                      this.setState({
                       is_login_open: false,
                       email :" ",
                       password : ""
                      })
                    }
                    elevation={5}
                    sx={{
                      height: 30,
                      width: 30,
                      borderRadius: 1,
                      backgroundColor: "#fff",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      mr: -1,
                      mt: -1,
                    }}
                  >
                    <CloseIcon
                      sx={{ height: 20, width: 20, color: "#2486bb" }}
                    />
                  </Paper>
                </Box>
                <Box
                  sx={{
                    overflowY: "scroll",
                    "&::-webkit-scrollbar": {
                      width: "5px",
                      borderRadius: 10,
                    },
                  }}
                >
         
 
                   <Grid container>
                     <Grid item  size={{xs:12,sm:12}}  >
                     <Box sx={{display:'flex',justifyContent:'center',width:'100%'}}>
                   <Box sx={{display:'flex',alignItems:'center',width:'100%'}}>
                     <Box sx={{display:'flex',flexDirection:'column',width:'100%'}}>
                   
                
                   <Box sx={{height:500,marginLeft:{xs:3,sm:3,md:5},marginRight:{xs:3,sm:3,md:5}}}>
                  
                   <Typography sx={{textAlign:'left',fontSize:{xs:19,sm:22},fontWeight:'600',marginTop:7,marginBottom:0.1}}>Login</Typography>
               
                   <Typography sx={{textAlign:'left',fontSize:{xs:11,sm:13},fontWeight:'600',marginTop:3,marginBottom:0.1}}>Email Id</Typography>
                   <Box sx={{border:1,borderRadius:1,borderColor:'#a2a2a6'}}>
                   <TextField
                   size='small'
                   sx={{padding:0.5,"& input::placeholder": {
                       fontSize: "13px"
                     }}}
                   fullWidth
                           id="input-with-icon-textfield"
                           placeholder='Email Id'
                           name='email'
                           onChange={this.handleChange}
                           value={this.state.email}
                           InputProps={{
                               disableUnderline: true,
                             startAdornment: (
                               <InputAdornment position="start">
                                 <PersonIcon style={{color:'#a2a2a6'}} />
                               </InputAdornment>
                             ),
                           }}
                           variant="standard"
                         />
                   
                   </Box>
                   
                   
                   <Typography sx={{textAlign:'left',fontSize:{xs:11,sm:13},fontWeight:'600',marginTop:1,marginBottom:0.1}}>Password</Typography>
                   <Box sx={{border:1,borderRadius:1,borderColor:'#a2a2a6'}}>
                   <TextField
                             id="filled-start-adornment"
                             sx={{padding:0.5,"& input::placeholder": {
                               fontSize: "13px"
                             }}}
                             name="password"
                             autoComplete='off'
                             value={this.state.password}
                           onChange={this.handleChange}
                             placeholder='Your Password'
                             size='small'
                             fullWidth
                             type= {this.state.showpassword?'text':'password'}
                             InputProps={{  
                              
                               disableUnderline: true,
                               endAdornment:(
                                   <InputAdornment position="start">
                                    {
                                     this.state.showpassword? <Visibility style={{color:'#a2a2a6'}} onClick={()=>this.setState({showpassword : false})}/>:<VisibilityOff onClick={()=>this.setState({showpassword : true})} style={{color:'#a2a2a6'}}/> 
                                    } 
                                   </InputAdornment>
                                 ),
                               startAdornment: (
                                   <InputAdornment position="start">
                                    <LockIcon style={{color:'#a2a2a6'}} />
                                   </InputAdornment>
                                 ),
                             }}
                             variant="standard"
                           />
                   
                   </Box>
                   
                   
                   
                   <Typography sx={{textAlign:'right',color:'red',fontSize:'13px',marginTop:2}}></Typography>
                   
                   
                   <Box sx={{marginTop:8}}>
                       <Button onClick={this.login}  type='submit'  variant="contained" fullWidth size='small' sx={{backgroundColor:'#2f84cf '}}>Login</Button>
                   </Box>
                   
                   
                   
                   
                 
                   
                   
                   </Box>
                     </Box>
                   </Box>
                   </Box>
                     </Grid>
               
                   </Grid>
                   




                </Box>
              </Paper>
            </Box>
          </Modal>
        </Box>





      </div>
    )
  }
}

export default Appbars

export function Appbarsc(props){
  const navigate = useNavigate();
  const location = useLocation();
  const param = useParams()
  return (<Appbars param={param} location={location} navigate={navigate}></Appbars>)}